import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';
import { ICON_STROKE_WIDTH } from 'constants/icons';

const BarChart2 = ({
  fill = COLOR.GRAY['900'],
  className = 'w-4 h-4',
  fillDarkMode = COLOR.SECONDARY.DARK_900,
  strokeWidth = ICON_STROKE_WIDTH.SMALL
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'>
      <g
        stroke={fillColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'>
        <path d='M18 20V10' />
        <path d='M12 20V4' />
        <path d='M6 20V14' />
      </g>
    </svg>
  );
};

export default BarChart2;
